export default __webpack_public_path__ + "static/media/Green geode_primary.7e7f3d45.jpg";